class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("change", this.onVariantChange);
    
    // Handle radio button clicks properly
    this.addEventListener("click", (event) => {
      if (event.target.type === "radio") {
        const radioButton = event.target;
        const fieldset = radioButton.closest('fieldset');
        

        

        
        if (fieldset) {
          // Clear all radio buttons in this fieldset
          const allRadios = fieldset.querySelectorAll('input[type="radio"]');
          allRadios.forEach(radio => {
            radio.checked = false;
          });
          
          // Check the clicked radio button
          radioButton.checked = true;
          
          // Update the legend display immediately
          const legendSpan = fieldset.querySelector('legend span');
          if (legendSpan) {
            legendSpan.textContent = radioButton.value;
          }
          
          // Trigger the change event manually
          this.onVariantChange();
        }
      }
    });
  }
  
  connectedCallback() {
    // Initialize when DOM is ready
    setTimeout(() => {

      
      this.updateOptions();
      this.updateVariantAvailability();
    }, 100);


  }

  onVariantChange() {
    this.updateOptions();
    this.updateOptionsParent();
    this.updateMasterId();
    this.updateVariantAvailability();
    
    this.toggleAddButton(true, "", false);
    this.getPreOrderVariantData();
    this.updatePickupAvailability();
    this.updateContent();

    if (!this.currentVariant) {
      this.toggleAddButton(true, "", true);
      this.setUnavailable();
    } else {
      // Update price immediately with current variant data before fetching
      this.updatePriceInstantly();
      
      // Wrap each update in try-catch to prevent one error from breaking everything
      try {
        this.updateMedia();
      } catch (error) {
        // Silently handle media errors
      }
      
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
    }
  }

  updateOptions() {
    // Check if we have radio buttons or select dropdowns
    const fieldsets = this.querySelectorAll('fieldset');
    if (fieldsets.length > 0) {
      // Radio buttons

      
      this.options = Array.from(fieldsets).map((fieldset, index) => {
        const checkedInput = fieldset.querySelector("input[type='radio']:checked");
        const result = checkedInput ? checkedInput.value : null;
        const fieldsetName = fieldset.querySelector('legend strong') ? fieldset.querySelector('legend strong').textContent : 'Unknown';
        

        
        return result;
      });
    } else {
      // Select dropdowns
      this.options = Array.from(
        this.querySelectorAll("select"),
        (select) => select.value
      );
    }
    

  }

  updateOptionsParent() {
    // Check if we have radio buttons or select dropdowns  
    const fieldsets = this.querySelectorAll('fieldset');
    if (fieldsets.length > 0) {
      // Radio buttons - update legend spans
      fieldsets.forEach((fieldset, index) => {
        const legend = fieldset.querySelector('legend span');
        if (legend && this.options[index]) {
          legend.textContent = this.options[index];
        }
      });
    } else {
      // Select dropdowns
      Array.from(this.querySelectorAll(".product-form__input--dropdown")).map(
        (select, index) => {
          select.children[0].children[1].innerHTML = this.options[index];
        }
      );
    }
  }

  updateMasterId() {
    const allVariants = this.getVariantData();
    
    this.currentVariant = allVariants.find((variant) => {
      const matches = variant.options.map((option, index) => {
        const match = this.options[index] === option;
        return match;
      });
      
      const allMatch = !matches.includes(false);
      return allMatch;
    });
    
    if (this.currentVariant) {
      // FORCE variant input update immediately
      this.updateVariantInput();
    }
  }

  updateVariantAvailability() {
    const variants = this.getVariantData();
    const fieldsets = this.querySelectorAll('fieldset');
    
    if (fieldsets.length <= 1) return; // Skip for single option products
    
    // Reset all labels
    fieldsets.forEach(fieldset => {
      const labels = fieldset.querySelectorAll('label');
      labels.forEach(label => {
        label.classList.remove('variant-unavailable', 'visually-disabled');
      });
    });
    
    // Get current selections
    const currentSelections = [];
    fieldsets.forEach((fieldset, index) => {
      const checkedInput = fieldset.querySelector('input[type="radio"]:checked');
      currentSelections[index] = checkedInput ? checkedInput.value : null;
    });
    
    // Check availability for each option
    fieldsets.forEach((fieldset, optionIndex) => {
      const inputs = fieldset.querySelectorAll('input[type="radio"]');
      
      inputs.forEach(input => {
        const value = input.value;
        let isAvailable = false;
        
        // Check if any available variant has this value at this position
        // and is compatible with other selected options
        for (let variant of variants) {
          if (!variant.available) continue;
          if (variant.options[optionIndex] !== value) continue;
          
          // Check compatibility with other selections
          let isCompatible = true;
          for (let i = 0; i < currentSelections.length; i++) {
            if (i === optionIndex) continue;
            if (currentSelections[i] && variant.options[i] !== currentSelections[i]) {
              isCompatible = false;
              break;
            }
          }
          
          if (isCompatible) {
            isAvailable = true;
            break;
          }
        }
        
        // Update visual state
        const label = fieldset.querySelector(`label[for="${input.id}"]`);
        if (label && !isAvailable) {
          label.classList.add('variant-unavailable', 'visually-disabled');
        }
      });
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    try {
      const mediaGallery = document.getElementById(
        `MediaGallery-${this.dataset.section}`
      );
      if (mediaGallery && typeof mediaGallery.setActiveMedia === 'function') {
        mediaGallery.setActiveMedia(
          `${this.dataset.section}-${this.currentVariant.featured_media.id}`,
          true
        );
      }
    } catch (error) {
      console.warn('⚠️ Error updating media gallery:', error);
      // Don't let media gallery errors prevent price updates
    }
  }

  updateContent() {
    let variant = this.currentVariant;

    let variandID = this.currentVariant?.id ?? null;

    // Back In Stock Notification
    let notifyMeAvailableWrapper = document.querySelector(
      ".notify__me--available"
    );
    if (variandID != null && !variant.available) {
      let soldOurtProductURL = document.querySelector(".soldout__product_url");
      soldOurtProductURL.value = `${this.dataset.origin}${this.dataset.url}?variant=${this.currentVariant.id}`;
      notifyMeAvailableWrapper.classList.remove("no-js-inline");
    } else {
      notifyMeAvailableWrapper.classList.add("no-js-inline");
    }
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === "false") return;
    window.history.replaceState(
      {},
      "",
      `${this.dataset.url}?variant=${this.currentVariant.id}`
    );
  }

  updateVariantInput() {
    if (!this.currentVariant) return;
    
    // Update all variant inputs on the page
    const allVariantInputs = document.querySelectorAll('input[name="id"]');
    allVariantInputs.forEach((input) => {
      input.value = this.currentVariant.id;
      input.setAttribute('value', this.currentVariant.id);
    });

    // Dispatch event to notify product form
    const variantChangeEvent = new CustomEvent('variantIdUpdated', {
      detail: {
        variantId: this.currentVariant.id,
        variant: this.currentVariant
      },
      bubbles: true
    });
    document.dispatchEvent(variantChangeEvent);
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector("pickup-availability");
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute("available");
      pickUpAvailability.innerHTML = "";
    }
  }

  updatePriceInstantly() {
    if (!this.currentVariant) return;
    
    // Format price instantly using Shopify's money format
    const price = this.currentVariant.price;
    const compareAtPrice = this.currentVariant.compare_at_price;
    
    // Update price display elements immediately
    const priceElements = document.querySelectorAll(`#price-${this.dataset.section} .price-item--sale, #price-${this.dataset.section} .price-item--regular`);
    if (priceElements.length > 0) {
      const formattedPrice = this.formatMoney(price);
      priceElements.forEach(el => {
        if (el.classList.contains('price-item--sale') || el.classList.contains('price-item--regular')) {
          el.textContent = formattedPrice;
        }
      });
    }
    
    // Update compare at price
    if (compareAtPrice && compareAtPrice > price) {
      const compareElements = document.querySelectorAll(`#price-${this.dataset.section} .price-item--regular`);
      if (compareElements.length > 0) {
        const formattedComparePrice = this.formatMoney(compareAtPrice);
        compareElements.forEach(el => {
          if (el.tagName === 'S') {
            el.textContent = formattedComparePrice;
          }
        });
      }
      
      // Update discount percentage instantly
      const discountPercent = Math.round(((compareAtPrice - price) / compareAtPrice) * 100);
      const discountElement = document.querySelector(`#discount-${this.dataset.section} .sale__save--percent`);
      if (discountElement) {
        discountElement.textContent = discountPercent;
      }
      
      // Show discount
      const discountWrapper = document.querySelector(`#discount-${this.dataset.section} .discount__sale__text`);
      if (discountWrapper) {
        discountWrapper.classList.remove('no-js-inline');
      }
    } else {
      // Hide discount if no sale
      const discountWrapper = document.querySelector(`#discount-${this.dataset.section} .discount__sale__text`);
      if (discountWrapper) {
        discountWrapper.classList.add('no-js-inline');
      }
    }
  }

  formatMoney(cents) {
    // Simple money formatter - adjust based on your shop's currency settings
    if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
      return Shopify.formatMoney(cents);
    }
    // Fallback format
    return 'Rs. ' + (cents / 100).toFixed(2);
  }

  renderProductInfo() {
    fetch(
      `${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`
    )
      .then((response) => response.text())
      .then((responseText) => {
        let id = `price-${this.dataset.section}`,
          stockInventory = `inventory__stock--${this.dataset.section}`,
          barcodeId = `barcode__${this.dataset.section}`,
          skuId = `sku__${this.dataset.section}`,
          discountId = `discount-${this.dataset.section}`;

        const html = new DOMParser().parseFromString(responseText, "text/html");

        let destination = document.getElementById(id),
          stockInventoryDestination = document.getElementById(stockInventory),
          barcodeDestination = document.getElementById(barcodeId),
          skuDestination = document.getElementById(skuId),
          discountDestination = document.getElementById(discountId);

        let source = html.getElementById(id),
          stockInventorySource = html.getElementById(stockInventory),
          barcodeSource = html.getElementById(barcodeId),
          skuSource = html.getElementById(skuId),
          discountSource = html.getElementById(discountId);

        if (source && destination) destination.innerHTML = source.innerHTML;
        if (stockInventorySource && stockInventoryDestination)
          stockInventoryDestination.innerHTML = stockInventorySource.innerHTML;
        if (barcodeSource && barcodeDestination)
          barcodeDestination.innerHTML = barcodeSource.innerHTML;
        if (skuSource && skuDestination)
          skuDestination.innerHTML = skuSource.innerHTML;
        if (discountSource && discountDestination)
          discountDestination.innerHTML = discountSource.innerHTML;

        const price = document.getElementById(`price-${this.dataset.section}`);
        if (price) price.classList.remove("no-js-inline");
        this.toggleAddButton(
          !this.currentVariant.available,
          window.variantStrings.soldOut
        );
      })
      .catch((error) => {
        console.error('Error fetching product info:', error);
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(
      `product-form-${this.dataset.section}`
    );
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');

    if (!addButton) return;

    if (disable) {
      addButton.setAttribute("disabled", true);
      if (text) addButton.textContent = text;
    } else {
      addButton.removeAttribute("disabled");
      addButton.textContent = window.variantStrings.addToCart;
    }

    // Preorder Button
    let productVarArray = this.PreorderVariantData;
    let variant = this.currentVariant;
    let VarInventoryManagement =
      this.currentVariant?.inventory_management ?? null;
    let var_num = "";
    if (VarInventoryManagement != null) {
      for (let variant_id in productVarArray) {
        if (variant.id == variant_id) {
          var_num = productVarArray[variant_id].qty;
          var inventoryQuantity = parseInt(var_num);
          var inventoryPolicy = productVarArray[variant_id].inventory_policy;
        }
        if (inventoryQuantity <= 0 && inventoryPolicy === "continue") {
          addButton.removeAttribute("disabled");
          addButton.textContent = window.variantStrings.preorder;
        } else if (inventoryQuantity <= 0 && inventoryPolicy !== "continue") {
          addButton.setAttribute("disabled", true);
          addButton.textContent = window.variantStrings.soldOut;
        } else {
          addButton.removeAttribute("disabled");
          addButton.textContent = window.variantStrings.addToCart;
        }
      }
    }
    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(
      `product-form-${this.dataset.section}`
    );
    const addButton = button.querySelector('[name="add"]');
    const price = document.getElementById(`price-${this.dataset.section}`);
    if (!addButton) return;
    addButton.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add("no-js-inline");
  }

  getVariantData() {
    this.variantData =
      this.variantData ||
      JSON.parse(this.querySelector("[data-variant]").textContent);
    return this.variantData;
  }
  getPreOrderVariantData() {
    this.PreorderVariantData =
      this.PreorderVariantData ||
      JSON.parse(this.querySelector("[data-preorder]").textContent);
  }
}

customElements.define("variant-selects", VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll("fieldset"));
    this.options = fieldsets.map((fieldset) => {
      const checkedInput = fieldset.querySelector("input:checked");
      return checkedInput ? checkedInput.value : null;
    });
  }

  updateOptionsParent() {
    const fieldsets = Array.from(this.querySelectorAll("fieldset"));
    fieldsets.forEach((fieldset, index) => {
      const legend = fieldset.querySelector('legend span');
      if (legend && this.options[index]) {
        legend.textContent = this.options[index];
      }
    });
  }
}
customElements.define("variant-radios", VariantRadios);
